import { renderEmptyStateMarkup } from '../emptyStateMarkup';

export const messagesPageMarkup = String.raw`
<div class="view" id="view-messages">
  <div class="msg-page">
    <main class="msg-main">
      <header class="msg-header" id="msgHeader">
        <h1 class="heading-1 msg-title">Messages</h1>
        <div class="msg-header-actions">
          <div class="msg-filter-pills" role="group" aria-label="Message status">
            <button class="msg-filter active" data-msg-filter="all" type="button" aria-pressed="true">All</button>
            <button class="msg-filter" data-msg-filter="unread" type="button" aria-pressed="false">Unread</button>
            <button class="msg-filter" data-msg-filter="read" type="button" aria-pressed="false">Read</button>
          </div>
          <button class="btn btn-outline msg-mark-all" id="msgMarkAllRead" type="button" disabled>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
            Mark all read
          </button>
        </div>
      </header>
      <div class="msg-summary-error" id="msgSummaryError" role="status" aria-live="polite" hidden>Message status is unavailable. <button type="button" id="msgSummaryRetry">Retry</button></div>
      <div class="msg-content" id="msgContent">
        <div class="msg-list" id="msgList" role="feed" aria-live="polite"></div>
        <div class="msg-skeleton" id="msgSkeleton" hidden></div>
        <div class="msg-error" id="msgListError" role="alert" hidden>
          <h3>Messages could not be loaded</h3>
          <p>Check your connection and try again.</p>
          <button class="btn btn-outline" type="button" id="msgListRetry">Retry</button>
        </div>
        <div class="msg-auth-required" id="msgAuthRequired" hidden>
          <div class="msg-empty-icon" aria-hidden="true"><svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3 5 6v5c0 5 3.4 8.6 7 10 3.6-1.4 7-5 7-10V6l-7-3Z"></path></svg></div>
          <h3>Sign in to see your messages</h3>
          <p>Notifications are private to your account.</p>
          <button class="btn btn-primary" type="button" data-proto-click="showLoginModal()">Sign in</button>
        </div>
        <div class="msg-empty" id="msgEmpty" hidden>${renderEmptyStateMarkup({ icon: 'inbox', title: "You're all caught up", subtitle: "No notifications here right now. We'll let you know when there's something new." })}</div>
      </div>
      <div class="msg-pagination-status" id="msgPaginationStatus" role="status" aria-live="polite"><span id="msgPaginationMessage"></span><button type="button" id="msgPaginationRetry" hidden>Retry</button></div>
      <div class="msg-sentinel" id="msgSentinel" aria-hidden="true"></div>
      <div class="msg-mutation-error" id="msgMutationError" role="status" aria-live="polite" hidden>Could not mark all messages as read. Please try again.</div>
    </main>
  </div>
</div>`;
